import companiesEdit from '@/views/companies/edit'
import companiesList from '@/views/companies/list'

export default [
  {
    path: '/empresas',
    name: 'companiesList',
    component: companiesList,
    meta: {
      layout: 'sidebar',
      type: 'list',
      base: 'companies',
      heading: 'menu.companies',
      auth: true,
      roles: [
        {
          create:  ['super-admin'],
          edit: ['super-admin'],
          remove: ['super-admin']
        }
      ]
    }
  },
  {
    path: '/empresas/novo',
    name: 'companiesCreate',
    component: companiesEdit,
    meta: {
      layout: 'sidebar',
      base: 'companies',
      heading: 'menu.companies',
      auth: true,
      roles: ['super-admin']
    }
  },
  {
    path: '/empresas/:id/editar',
    name: 'companiesUpdate',
    component: companiesEdit,
    meta: {
      layout: 'sidebar',
      base: 'companies',
      heading: 'menu.companies',
      auth: true,
      roles: ['super-admin']
    }
  }
]
